import { Component } from '@angular/core';

// import { StateService } from '../../services/state/state';
import { Environment } from '../../../environments/environment';
import { Desktop } from './desktop/desktop';
import { Mobile } from './mobile/mobile';

@Component({
  imports: [Desktop, Mobile],
  selector: 'app-toolbar',
  styleUrl: './toolbar.css',
  templateUrl: './toolbar.html',
})
export class Toolbar {
  // private readonly stateService = inject(StateService);

  public modelGalleryClicked(): void {
    // if (environment.isApp) {
    //   // Bubble the event up so it can be handled at a higher level.
    //   this.stateService.notifyParentOfStateChange('HF_EVENT:MODEL_GALLERY_CLICKED');
    // }
    // else {
    const _origin = Environment.isApp ? 'https://www.thevillages.com' : '';
    const _comminityPath = Environment.community === 'villages' ? 'home-series' : 'homes';
    const _url = `${_origin}/${_comminityPath}/`;

    window.open(_url, '_blank');
    // }
  }
}
